<template>
  <div class="Perfect" v-title data-title="完善个人信息">
    <!-- <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.go(-1)"> 
      <p>
        完善个人信息
      </p>
    </header> -->
    <section>
      <div class="per-msg">
        <p class="title">
          请真实填写您的个人信息
        </p>
        <div class="name">
          <p>姓名</p>
          <p>
            <input type="text" placeholder="请输入姓名" v-model="realname">
          </p>
        </div>
        <div class="sex">
          <p>性别</p>
          <p>
            <input type="text" placeholder="请选择" readonly @click="sexSelect" v-model="sex">
          </p>
        </div>
        <div class="phone">
          <p>手机号</p>
          <p>
            <input type="text" placeholder="请输入" v-model="phone">
          </p>
        </div>
        <div id="code">
          <p><input type="number" placeholder="请输入验证码" v-model="user_activation_key" @blur="blurText"></p>
          <p>
            <button @click="codeBtn" :disabled="isdisabled" >{{btnTitle}}</button>
          </p>
        </div>
        <div class="address">
          <p>收货地址</p>
          <p>
            <input type="text" placeholder="请选择" readonly v-model="userlist.address" @click="showAddressChuang" style="width: 4.5rem">
          </p>
        </div>
        <div class="detail-address">
          <p>详细地址</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem" v-model="addressMsg">
          </p>
        </div>
        <div class="work">
          <p>行业背景</p>
          <p>
            <input type="text" placeholder="请输入" v-model="job">
          </p>
        </div>
        <div class="id-card">
          <p>身份证号码</p>
          <p>
            <input type="text" placeholder="请输入" v-model="card_no" style="width: 4rem">
          </p>
        </div>
        <!-- <p class="title-tow">
          银行卡信息
        </p>
        <div class="id-card">
          <p>持卡人姓名</p>
          <p>
            <input type="text" placeholder="请输入">
          </p>
        </div>
        <div class="id-card">
          <p>开户行信息</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem">
          </p>
        </div>
        <div class="id-card">
          <p>卡号</p>
          <p>
            <input type="text" placeholder="请输入" style="width: 4rem">
          </p>
        </div> -->
      </div>
      <!-- 提交按钮 -->
      <p class="sub-btn" @click="submitBtn">
        提交
      </p>
    </section>
    <!-- 性别选择 -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <!-- 住址选择 -->
    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area
        :area-list="areaList"
        :value="areaCode"
        @confirm="sure"
        @cancel="exit"
      />
    </van-popup>
  </div>
</template>
<script>

import Vue from 'vue';
import addressList from '../../../public/addressList/area'
import { ActionSheet, Area, Popup, Toast} from 'vant';
import qs from 'qs';

Vue.use(Toast)
Vue.use(ActionSheet);
Vue.use(Area);
Vue.use(Popup);

export default {
  data(){
    return{
      url:'',
      show: false,
      // 选择性别组件
      actions: [
        { name: '男' , code: '1'},
        { name: '女' , code: '2' },
      ],
      sex: '', // 性别
      sexcode: '', // 1,2
      phone: '' , // 手机号
      btnTitle: '获取验证码', // 验证码文字
      isdisabled: false, 
      user_activation_key: '', // 验证码
      userlist: [], // 现住址
      showAddress: false, // 先住址弹窗
      areaList: addressList, // 选中省市区
      areaCode:'', // 选中省市区的code 
      realname: '', // 真实姓名
      addressMsg: '', // 详细地址
      job: '', //行业背景
      card_no : '', // 身份证号


    }
  },
  created(){
    this.url = this.$route.path

    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    if(!uid){
      // 授权登录
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(window.location.href)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        window.localStorage.removeItem('uid');
        // 传code
        this.$axios.get(this.domain.url+"/api/user/public/login",{
        params:{
          code : wxcode,
          url : this.domain.local_url
        },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }


    // 查询是否完善信息
    this.$axios.get(this.domain.url+"/api/user/public/integrality").then((res) => {
      // console.log(res.data)
      // 已完善
      if(res.data.code == 1){
        // 查询信息
        this.$axios.get(this.domain.url+"/api/user/public/userinfo").then((res) => {
          // console.log(res.data.data)
          let myMsg = res.data.data
          this.realname = myMsg.realname
          this.sex = myMsg.sex
          // this.sex == 1 ?'男':'女'
          if(this.sex == 1){
            this.sex = '男'
          }else{
            this.sex = '女'
          }
          this.sexcode = myMsg.sex
          this.phone = myMsg.mobile
          this.userlist.address = myMsg.city
          this.addressMsg = myMsg.address
          this.job = myMsg.job
          this.card_no = myMsg.card_no
        })
      }
    })
  },
  methods:{
    // 性别组件
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.sex = item.name
      this.show = false;
      this.sexcode = item.code
    },
    // 性别选择
    sexSelect(){
      this.show = true
    },
    // 手机验证码
    codeBtn() {
      if(!this.phone) {
        Toast('手机号码不能为空');
        // return false
      } else if(!/^1[345678]\d{9}$/.test(this.phone)) {
        Toast('请输入正确是手机号');
      }else{
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
        if(time == 0) {
          clearInterval(timer);
          this.btnTitle = "获取验证码";
          this.isdisabled = false;
        } else {
          this.isdisabled = true;
          this.btnTitle =time + '秒后重试';
          time--
        }
        },1000)
        let parms = {
          username : this.phone
        }
        // 验证码验证
        this.$axios.post(this.domain.url+'/api/user/verification_code/send',qs.stringify(parms))
        .then((res) => {
          // console.log(res)
        })
      }
    },
    // 收货地址
    showAddressChuang(){
      this.showAddress = true
    },
    // 选择地址完成按钮
    sure(val){
      this.showAddress = false
      // console.log(val)
      this.userlist.address = val[0].name + "/"+val[1].name+"/"+val[2].name;
      // console.log(this.userlist)
    },
    // 选择地址取消按钮
    exit(){
      this.showAddress = false
    },
    // 提交信息
    submitBtn(){
      console.log(this.realname)
      if(!this.realname){
        Toast('请输入真实姓名');
      }else if(!this.sexcode){
        Toast('请选择性别');
      }else if(!this.phone){
        Toast('请输入手机号');
      }else if(!this.user_activation_key){
        Toast('请输入验证码');
      }else if(!this.userlist.address){
        Toast('请输入详细地址');
      }else if(!this.job){
        Toast('请输入行业信息');
      }else if(!this.card_no){
        Toast('请输入身份证号码');
      }else{
        // let usrId=JSON.parse(localStorage.getItem("uid"));
        let parms = {
          realname : this.realname,
          sex : this.sexcode,
          mobile : this.phone,
          user_activation_key : this.user_activation_key,
          city : this.userlist.address,
          address : this.addressMsg,
          job : this.job,
          card_no : this.card_no,
          // address_number : 
        }
        // console.log(parms)
        // 提交信息接口
        this.$axios.post(this.domain.url+'/api/user/public/edituserinfo',qs.stringify(parms)).then((res) => {
          // console.log(res)
          if(res.data.code == 1){
            Toast('信息提交成功');
            this.$router.go(-1)
          }else{
          }
        })
      }

    },
    // 验证码失去焦点
    blurText(){
      if(this.user_activation_key){
        this.$axios.get(this.domain.url+'/api/user/profile/codeverify',{
        params:{
          mobile : this.phone,
          verification_code : this.user_activation_key
        }
        }).then(res => {
          // console.log(res)
          if(res.data.code == 1){
            Toast(res.data.msg);
          }else{
            Toast(res.data.msg);
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .Perfect{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      overflow: scroll;
      // 填写个人信息
      .per-msg{
        width: 6.9rem;
        // height: 8rem;
        margin: 0 auto;
        box-shadow: 0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
        margin-top: .2rem;
        margin-bottom: .48rem;
        overflow: hidden;
        padding-bottom: .3rem;
        // 标题
        .title{
          width: 100%;
          text-align: center;
          font-family: PingFang-SC-Medium;
          color: #EF8201;
          font-size: 0.3rem;
          line-height: .3rem;
          margin-top: .42rem;
          margin-bottom: .43rem;
        }
        #code{
          p{
            &:first-child{
              // margin-left: .25rem;
              input{
                font-size: .24rem;
                line-height: .3rem;
                height: .3rem;
                border: none;
                outline: none;
              }
            }

          }
        }
        div{
          width: 6.32rem;
          height: 0.88rem;
          border: .01rem #E4E4E4 solid;
          margin: 0 auto;
          margin-top: .2rem;
          border-radius: .1rem;
          // display: flex;
          p{
            color: #999999;
            font-family: PingFang-SC-Medium;
            &:nth-child(1){
              float: left;
              margin-left: .25rem;
              font-size: 0.3rem;
              line-height: .88rem;
            }
            &:last-child{
              height: .88rem;
              display: flex;
              align-items: center;
              float: right;
              font-size: 0.24rem;
              margin-right: .22rem;
              input{
                text-align: right;
                border: none;
                outline: none;
                color: #999999;
              }
            }
          }
        }
        // 银行卡标题
        .title-tow{
          width: 100%;
          text-align: center;
          font-family: PingFang-SC-Medium;
          color: #EF8201;
          font-size: 0.3rem;
          line-height: .3rem;
          margin-top: .35rem;
          margin-bottom: .29rem;
        }
      }
      // 提交按钮
      .sub-btn{
        width: 4.8rem;
        height: .88rem;
        text-align: center;
        line-height: .88rem;
        background: #EF8201;
        font-family: PingFang-SC-Bold;
        font-weight: Bold;
        color: #ffffff;
        font-size: 0.36rem;
        margin: 0 auto;
        margin-bottom: .46rem;
      }
    }
  }
</style>